'use strict';
define(function () {

    var MS_USER_COOKIE = 'MS_USER_COOKIE',
        MS_SPARKS_PAY = /MS_SP_C=([^;]+)/,
        MS_PREFERRED_COUNTRY = 'MS_PREFERRED_COUNTRY',
        MS_USER_SEGMENT_COOKIE = /MS_USER_SEGMENT_COOKIE=([^;]+)/,
        BASKET_COOKIE = 'basketSize_[0-9]+',
        SAVED_ITEM_COOKIE = 'savedItemSize_[0-9]+',
        MS_AUTH_TOKEN = /MS_AUTH_TOKEN_\d+=([^;]+)/,
        IS_LOYALTY_USER_COOKIE = /IS_LOYALTY_USER_COOKIE=([^;]+)/,
        config = window.mnsHeaderConfig ? window.mnsHeaderConfig : {};

    /**
     * Returns userSegment_XXXX cookie value
     * @returns {Number | null} userSegment_XXXX value
     */
    function getUserSegmentCookieValue() {
        var matches = document.cookie.match(MS_USER_SEGMENT_COOKIE);

        return matches !== null ? matches[1] : null;
    }

    /**
     * Returns MS_AUTH_TOKEN_[0-9]+ cookie value
     * @returns {string | null} MS_AUTH_TOKEN_ value
     */
    function getAuthTokenCookieValue() {
        var matches = document.cookie.match(MS_AUTH_TOKEN);

        return matches !== null ? matches[1] : null;
    }

    /**
     * Returns logged in user status from MS_USER_COOKIE
     * @returns {boolean} TRUE if user is logged in
     */
    function isUserLoggedIn() {
        return getUserCookieValue() !== null;
    }

    /**
     * Returns username from MS_USER_COOKIE
     * @returns {string | null} username
     */
    function getUsername() {
        var value = getUserCookieValue();

        return value !== null ? value.split('_')[0] : null;
    }

    /**
     * Returns loyalty username from IS_LOYALTY_USER_COOKIE
     * @returns {string | null} username
     */
    function isUserSparksMember() {
        var matches = document.cookie.match(IS_LOYALTY_USER_COOKIE);
        return matches !== null ? matches[1] === 'true' : false;
    }

    /**
     * Returns loyalty username from IS_LOYALTY_USER_COOKIE
     * @returns {string | null} username
     */
    function getStoreIdSuffixCookieValue(patternStr) {
        var cookieKey,
            cookieVal,
            cookiePattern = patternStr + '=',
            storeAwareCookiePattern;

        if (config.MS_MAKE_STORE_AWARE_COOKIE) {
            // read store aware cookie
            storeAwareCookiePattern = patternStr + '_'  + config.storeId + '=';
            cookieVal = getCookieValue(storeAwareCookiePattern);

            if (cookieVal) {
                return cookieVal;
            }

            // read existing cookie
            cookieVal = getCookieValue(cookiePattern);

            if (cookieVal) {
                cookieKey = getCookieKey(cookiePattern);
                setCookieWithOptions((cookieKey + '_' + config.storeId), cookieVal);
            }

            return cookieVal;
        }

        return getCookieValue(cookiePattern);
    }

    function setCookieWithOptions(key, value, options, raw, json) {
        options = options ? options : {};
        raw = raw ? raw : false;
        json = json ? json : false;

        if (typeof options.expires === 'number') {
            const days = options.expires;
            const date = new Date();
            date.setDate(date.getDate() + days);
            options.expires = date.toUTCString();
        }

        value = json ? JSON.stringify(value) : String(value);
        value = raw ? value : encodeURIComponent(value);
        const keyValue = `${encodeURIComponent(key)}=${value};`;

        const optionsString = Object.keys(options)
            .map(option => {
                if (option === 'Secure') {
                    return option;
                }
                return `${option}=${options[option]}`;
            })
            .join(';');

        return document.cookie = `${keyValue} ${optionsString}`;
    }

    function getCookieKey(patternStr) {
        var pattern = new RegExp(patternStr + '[^;]+'),
            matches = document.cookie.match(pattern);
        return matches && matches[0] ? matches[0].split('=')[0] :null;
    }

    function getCookieValue(patternStr) {
        var pattern = new RegExp(patternStr + '[^;]+'),
            matches = document.cookie.match(pattern);

        return matches && matches[0] ? matches[0].split('=')[1] : null;
    }

    function getUserCookieValue() {
        return getStoreIdSuffixCookieValue(MS_USER_COOKIE);
    }

    function getBasketCookieValue() {
        return getStoreIdSuffixCookieValue(BASKET_COOKIE) || 0;
    }

    function getSavedItemsCookieValue() {
        return getStoreIdSuffixCookieValue(SAVED_ITEM_COOKIE) || 0;
    }

    function updatePreferredCountryCookie(evt) {
        if(evt && evt.target && evt.target.dataset && evt.target.dataset.lang && evt.target.dataset.countryname) {
            var value = (evt.target.dataset.lang).toLowerCase() + '_' + evt.target.dataset.countryname;
            setCookieWithOptions(MS_PREFERRED_COUNTRY, value, { path: '/' });
        }
    }

    function getUserSparkspayStatus(){
        var  sparkspaymatches = document.cookie.match(MS_SPARKS_PAY);
        return sparkspaymatches && sparkspaymatches[0] ? sparkspaymatches[0].split(',')[1] : null;
    }

    // service API
    return {
        isUserLoggedIn: isUserLoggedIn,
        getUsername: getUsername,
        getCookieValue: getCookieValue,
        getUserLoginCookieValue: getUserCookieValue,
        getUserSegmentCookieValue: getUserSegmentCookieValue,
        getBasketSizeCookieValue: getBasketCookieValue,
        getSavedItemCountCookieValue: getSavedItemsCookieValue,
        getAuthTokenCookieValue: getAuthTokenCookieValue,
        isUserSparksMember: isUserSparksMember,
        updatePreferredCountryCookie: updatePreferredCountryCookie,
        getUserSparkspayStatus:getUserSparkspayStatus
    };
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/links/cookieService.js